import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SocialAuthService } from "@abacritt/angularx-social-login";
import { SocialUser } from "@abacritt/angularx-social-login";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private router: Router, private socialAuthService: SocialAuthService) {
  }

  checkAuthState(): boolean {
    let flag = false;
    this.socialAuthService.authState.subscribe({
      next: (socialUser: SocialUser) => {
        console.log(socialUser)
        if (socialUser) {
          flag = true;
        }
      }
    });
    return flag;
  }

}
